import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { Sparkles, MessageSquare, Bot, ScanText, FileSearch, GitBranch, PenTool, Plug, Activity } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "Generative AI Solutions",
        icon: <Sparkles size="64" strokeWidth='1' />,
        content: "We build generative AI features into your products — from content generation to intelligent search — using the latest large language models."
    },
    {
        id: 2,
        title: "AI Chatbots & Virtual Assistants",
        icon: <MessageSquare size="64" strokeWidth='1' />,
        content: "Custom AI chatbots and virtual assistants that handle support, sales, and internal workflows around the clock."
    },
    {
        id: 3,
        title: "AI Agents & Workflow Automation",
        icon: <Bot size="64" strokeWidth='1' />,
        content: "Autonomous AI agents that take multi-step actions across your tools, automating workflows that used to require manual effort."
    },
    {
        id: 4,
        title: "RAG Applications & Document AI/OCR",
        icon: <ScanText size="64" strokeWidth='1' />,
        content: "Retrieval-augmented generation applications and document AI/OCR pipelines that turn your unstructured documents into searchable, actionable data."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "Generative AI Integration",
        icon: <Sparkles size="42" strokeWidth='1' />,
        content: "Integrate generative AI capabilities directly into your existing products."
    },
    {
        id: 2,
        title: "AI Chatbot Development",
        icon: <MessageSquare size="42" strokeWidth='1' />,
        content: "Conversational AI chatbots tailored to your business and customers."
    },
    {
        id: 3,
        title: "Autonomous AI Agents",
        icon: <Bot size="42" strokeWidth='1' />,
        content: "AI agents that plan, decide, and act across multiple tools and systems."
    },
    {
        id: 4,
        title: "RAG (Retrieval-Augmented Generation)",
        icon: <FileSearch size="42" strokeWidth='1' />,
        content: "Ground AI responses in your own data with retrieval-augmented generation."
    },
    {
        id: 5,
        title: "Document AI / OCR",
        icon: <ScanText size="42" strokeWidth='1' />,
        content: "Extract structured data from documents, forms, and scans automatically."
    },
    {
        id: 6,
        title: "Workflow Automation",
        icon: <GitBranch size="42" strokeWidth='1' />,
        content: "End-to-end automation of business workflows powered by AI."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Prompt Engineering",
        icon: <PenTool size="54" strokeWidth='1' />,
        content: "Carefully engineered prompts that make AI features reliable and predictable."
    },
    {
        id: 2,
        title: "AI Model Integration",
        icon: <Plug size="54" strokeWidth='1' />,
        content: "Integrate leading AI models and providers into your existing systems."
    },
    {
        id: 3,
        title: "AI Ops & Monitoring",
        icon: <Activity size="54" strokeWidth='1' />,
        content: "Ongoing monitoring of AI features in production for quality and cost."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const AIAutomation = () => {
    return (
        <>
            <PageHelmet
                pageTitle="AI Development Services & Intelligent Automation"
                description="Harsoft Solutions provides AI development services — generative AI, AI chatbots, AI agents, RAG applications, and document AI/OCR to automate your business workflows."
                keywords="AI Development Services, Generative AI, AI Chatbots, AI Agents, RAG, Document AI, Workflow Automation"
                path="/ai-automation"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="AI & Intelligent Automation" subtitle="AI & Intelligent Automation" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="AI Development Services That Automate Real Work" content="Our AI development services span generative AI, AI chatbots, autonomous AI agents, RAG applications, and document AI/OCR — turning intelligent automation into measurable business results." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/expart/expart-1.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default AIAutomation;
